import { styled } from '@mui/material';

export const Wrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-medium)',
});
